import { IUserProfile } from './getUserProfile.types';

export const userWithAllProfileData: IUserProfile = {
  user: {
    firstName: 'John',
    lastName: 'Doe',
    email: 'jdoe@me.com',
    phoneNumber: '+498765456543',
    whatsappPhoneNumber: '+201559554199',
    whatsappConsent: true,
  },
  company: {
    companyName: 'Metycle',
    address: '123 Main St',
    postalCode: '12345',
    vatNumber: '123456789',
  },
};

export const userWithMissingCompanyData: IUserProfile = {
  user: { ...userWithAllProfileData.user },
  company: {
    companyName: 'Metycle',
  },
};

export const testUserProfileWithWhatsAppConsentAndNumber: IUserProfile = {
  user: { ...userWithAllProfileData.user, whatsappConsent: false },
  company: { ...userWithAllProfileData.company },
};

export const userWithWhatsAppConsentButNoNumber: IUserProfile = {
  user: {
    ...userWithAllProfileData.user,
    whatsappPhoneNumber: '',
    whatsappConsent: true,
  },
  company: { ...userWithAllProfileData.company },
};

export const userWithoutConsentButWithNumber: IUserProfile = {
  ...userWithAllProfileData,
  user: {
    ...userWithAllProfileData.user,
    whatsappConsent: false,
    whatsappPhoneNumber: '+4912345678901',
  },
};

export const userWithoutConsentAndNoNumber: IUserProfile = {
  ...userWithAllProfileData,
  user: {
    ...userWithAllProfileData.user,
    whatsappConsent: false,
    whatsappPhoneNumber: '',
  },
};
